import { sha256Hex } from './sha256';

function sortValue(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sortValue);
  if (!value || typeof value !== 'object') return value;
  const out: Record<string, unknown> = {};
  for (const key of Object.keys(value as Record<string, unknown>).sort()) {
    if (key === 'checksum') continue;
    const child = (value as Record<string, unknown>)[key];
    if (child === undefined) continue;
    out[key] = sortValue(child);
  }
  return out;
}

/** Sorted keys, no whitespace. The checksum field is left out of the bytes it covers. */
export function canonicalJson(value: unknown): string {
  return JSON.stringify(sortValue(value));
}

export function checksumOf(value: unknown): string {
  return sha256Hex(canonicalJson(value));
}
